import React from 'react';
import OverlayContext from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard/Overlay/OverlayContext';
import s from './BasePaywall.scss';

export interface Props {
  className?: string;
  children: React.ReactNode;
  icon: React.ReactNode;
  text: string | React.ReactNode;
  button: React.ReactNode;
  title?: string;
  overlayOffset?: {
    [dir: string]: number;
  };
}

const BasePaywall: React.FC<Props> = ({
  children,
  icon,
  title,
  text,
  button,
  overlayOffset,
}) => (
  <OverlayContext.Consumer>
    {value => (
      <OverlayContext.Provider
        value={{
          ...value,
          showPremiumFolderOverlay: false,
        }}
      >
        <div className={s['root']}>
          <div className={s['content']}>{children}</div>
          <div className={s['overlay']} style={overlayOffset}>
            <div className={s['overlay-bg']} />
            <div className={s['distancer']}></div>
            <div className={s['overlay-content']}>
              <div className={s['icon']}> {icon} </div>
              {title && <div className={s['title']}> {title} </div>}
              <div className={s['text']}> {text} </div>
              {button}
            </div>
          </div>
        </div>
      </OverlayContext.Provider>
    )}
  </OverlayContext.Consumer>
);
BasePaywall.displayName = 'BasePaywall';

export default BasePaywall;
